import styled from 'styled-components';
import { Steps as AntdSteps } from 'antd';
import { StepsProps } from 'antd/lib/steps';

type StepChildren = {
  children: React.ReactNode;
};

type StepCustomProps = StepsProps | StepChildren;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};

  box-shadow: ${({ theme }) => theme.commoms.boxShadow};
  border: none;

  & > .hefesto-step-by-step .hefesto-icon {
    width: 1rem;
  }

  .hefesto-step-by-step__content {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.section`
  padding: 0 1.5rem 0rem 1.5rem;
  .hefesto-step-by-step {
    width: 100%;
    margin-right: 0;
  }
`;

export const TitleBox = styled.div`
  & > h2 {
    margin: unset;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.grayDark3};
  }

  & > span {
    font-size: 1rem;
  }

  padding-top: 0;
`;

export const Steps = styled(AntdSteps)<StepCustomProps>`
  width: 10rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 65%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    width: 45%;
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  width: 100%;
  .hefesto-step-by-step__content .hefesto-step-by-step__step--finished {
    display: flex;
    align-items: center;
    position: relative;
    .hefesto-icon.Check {
      top: 40%;
      left: 1rem;
      width: fit-content;
    }
  }
`;

export const CustomTitleWrapper = styled.div`
  padding: 1.5rem 0;
  h1 {
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grayDark3};
    font-family: 'Source Sans Pro';
    font-size: 3rem;
    line-height: 3.5rem;
  }
  span {
    color: ${({ theme }) => theme.colors.grayDark3};
  }
`;
